import * as React from 'react';
import { SearchInput } from '../../components/SearchInput';
import { useDispatch, useSelector } from 'react-redux';
import { setSearchText } from '../../actions/filters';
import { selectSearchText } from '../../selectors/filters';
import { fetchBuildersInfo } from '../../actions/buildersInfo';
import { TThunkDispatch } from '../../types/redux';

export function SearchInputContainer() {
  const searchText = useSelector(selectSearchText);
  const dispatch: TThunkDispatch = useDispatch();

  const handleChange = React.useCallback(
    (value: string) => {
      dispatch(setSearchText(value));
    },
    [dispatch],
  );

  const handleSubmit = React.useCallback(() => {
    dispatch(fetchBuildersInfo());
  }, [dispatch]);

  return <SearchInput value={searchText} onChange={handleChange} onSubmit={handleSubmit} />;
}
